import { Sky, ContactShadows, Environment as DreiEnvironment, Stars, Sparkles } from '@react-three/drei';

export const Environment = () => {
  return (
    <>
      <color attach="background" args={['#000000']} />
      
      {/* High-end Studio Lighting */}
      <ambientLight intensity={0.1} />
      <directionalLight position={[5, 10, 5]} intensity={0.5} />
      <pointLight position={[10, 10, -10]} intensity={1} color="#ffffff" />
      <pointLight position={[-10, 5, 10]} intensity={0.5} color="#444" />
      
      <DreiEnvironment preset="night" />
    </>
  );
};
